import { render, staticRenderFns } from "./Nominee.vue?vue&type=template&id=ad2dd484"
import script from "./Nominee.vue?vue&type=script&lang=js"
export * from "./Nominee.vue?vue&type=script&lang=js"
import style0 from "./Nominee.vue?vue&type=style&index=0&id=ad2dd484&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports